import { render, staticRenderFns } from "./AuthPage.vue?vue&type=template&id=1597bb8f&scoped=true"
import script from "./AuthPage.vue?vue&type=script&lang=js"
export * from "./AuthPage.vue?vue&type=script&lang=js"
import style0 from "./AuthPage.vue?vue&type=style&index=0&id=1597bb8f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1597bb8f",
  null
  
)

export default component.exports